// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ValidationErrorSchema = z.object({
  errors: z.object({}).describe("Validation errors"),
});
